import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ElevatorBank } from '../../stacking-plan.model';
import { Toolbar } from '../../actions-toolbar/actions-toolbar.model';
import { UpdateStackingPlanInfo } from '../../floor-container/floor/floor.model';
import { FloorClass } from '../../../models/floor.class';

@Component({
  selector: 'sp-more-info-dialog',
  templateUrl: './more-info-dialog.component.html',
  styleUrls: ['./more-info-dialog.component.scss'],
  standalone: false,
})
export class MoreInfoDialogComponent implements OnInit, OnDestroy {
  floorData: FloorClass[];
  elevatorInfo: ElevatorBank[];
  floorsHeaderData: Toolbar;
  elevatorSelectedFloors: number[] = [];
  localeId: number;

  constructor(
    public dialogRef: MatDialogRef<MoreInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.floorData = data.floorsElevatorsInfo.floorInfo;
    this.elevatorInfo = data.floorsElevatorsInfo.elevatorInfo;
    this.floorsHeaderData = data.floorsHeaderData;
    this.localeId = data.localeId;
  }

  ngOnInit(): void {
    this.elevatorSelectedFloors = this.elevatorInfo.reduce((acc, elevator) => {
      return [...acc, parseInt(elevator.firstStop), parseInt(elevator.lastStop)];
    }, []);
  }

  ngOnDestroy(): void {
    /* required by angular-l10n */
  }

  /**
   * It will receive the latest/updated elevator data through output event
   * emitter, when the save button clicked in elevator component.
   * Here it will send the elevators data to its parent component
   * (actionToolbar) and Closes the more info dialog box once.
   */
  updateElevatorData(elevatorBank: UpdateStackingPlanInfo) {
    this.dialogRef.close({ ...elevatorBank });
  }

  /**
   * It will receive the latest/updated floors data through output event
   * emitter, when the save button clicked in floors component.
   * Here it will send the floors data to its parent component(actionToolbar)
   * and Closes the more info dialog box once.
   */
  updatedFloorData(floorToolbarData: UpdateStackingPlanInfo) {
    this.dialogRef.close(floorToolbarData);
  }
}
